// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1Rq6i","tab":"Tabs_tab__3coU0","tabActive":"Tabs_tabActive__NiyRr"};